import { UNSAFE_noExposureExp } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';

import { COHORTS } from '../utils/experimentConfig';

type ExperimentEnrollment = {
	cohort: string;
	isTreatment: boolean;
	isEnrolled: boolean;
};

export const useExperimentEnrollment = (): ExperimentEnrollment => {
	const isGateEnabled = fg('confluence_eot_premium_recommend_standard_buy_fg');
	const [expConfig] = UNSAFE_noExposureExp('confluence_eot_premium_recommend_standard_buy');
	const cohort = expConfig.get('cohort', COHORTS.NOT_ENROLLED);
	return {
		cohort,
		isTreatment: isGateEnabled && cohort === COHORTS.TREATMENT,
		isEnrolled: isGateEnabled && (cohort === COHORTS.TREATMENT || cohort === COHORTS.CONTROL),
	};
};
